/* eslint-disable */
import { combineReducers } from 'redux';
export default combineReducers({});
